import { CHUNK_SIZE } from '../constants.js';
// Convert world coordinates to chunk coordinates
export const worldToChunk = ({ x, y }) => {
    return {
        x: Math.floor(x / CHUNK_SIZE),
        y: Math.floor(y / CHUNK_SIZE),
    };
};
// Convert chunk coordinates to world coordinates (top-left corner)
export const chunkToWorld = ({ x, y }) => {
    return {
        x: x * CHUNK_SIZE,
        y: y * CHUNK_SIZE,
    };
};
// Get local tile position within a chunk
export const worldToLocalTile = ({ x, y }) => {
    return {
        x: ((Math.floor(x) % CHUNK_SIZE) + CHUNK_SIZE) % CHUNK_SIZE,
        y: ((Math.floor(y) % CHUNK_SIZE) + CHUNK_SIZE) % CHUNK_SIZE,
    };
};
// Create a unique key for chunk coordinates (for use in Maps)
// DEPRECATED: Use chunkKeyInt for better performance in hot paths
export const chunkKey = ({ x, y }) => {
    return `${x},${y}`;
};
// ============================================================================
// Integer Keys - For performance-critical hot paths (avoids string allocation)
// Pack two 16-bit signed integers into one 32-bit integer
// Supports coordinates from -32768 to 32767
// ============================================================================
// Integer key for tile/chunk coordinates - use in hot paths
export const tileKeyInt = ({ x, y }) => {
    return ((x & 0xffff) << 16) | (y & 0xffff);
};
// Alias for tile key (same operation, clearer naming for chunks)
export const chunkKeyInt = tileKeyInt;
// Unpack integer key back to coordinates
export const unpackKeyInt = (key) => {
    // Sign-extend the 16-bit values
    const x = ((key >> 16) << 16) >> 16;
    const y = (key << 16) >> 16;
    return { x, y };
};
// Parse chunk key back to coordinates
export const parseChunkKey = (key) => {
    const [xStr, yStr] = key.split(',');
    return {
        x: Number.parseInt(xStr ?? '0', 10),
        y: Number.parseInt(yStr ?? '0', 10),
    };
};
// Get all chunk keys within a radius
export const getChunksInRadius = ({ centerX, centerY, radius, }) => {
    const chunks = [];
    for (let dy = -radius; dy <= radius; dy++) {
        for (let dx = -radius; dx <= radius; dx++) {
            chunks.push({ x: centerX + dx, y: centerY + dy });
        }
    }
    return chunks;
};
// Get tile index in flat array from local coordinates
export const tileIndex = ({ x, y }) => {
    return y * CHUNK_SIZE + x;
};
// Get local coordinates from tile index
export const indexToTile = (index) => {
    return {
        x: index % CHUNK_SIZE,
        y: Math.floor(index / CHUNK_SIZE),
    };
};
//# sourceMappingURL=chunk.js.map